export default ["M8 0a3 3 0 00-3 3v4a3 3 0 006 0V3a3 3 0 00-3-3zM3 5a1 1 0 011 1v2a3 3 0 003 3h2a3 3 0 003-3V6a1 1 0 112 0v2a5 5 0 01-5 5v1h1a1 1 0 110 2H6a1 1 0 110-2h1v-1a5 5 0 01-5-5V6a1 1 0 011-1z"];
